import { useMemo, useState } from 'react'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOAD_DATA: 'Carregando informações',
}

const INITIAL_STATE = {
  data: [],
  entregas: [],
  byCompany: [],
  byCity: [],
  ufLabel: null,
  activeTabIndex: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  total: { nfs: 0, volumes: 0, sku: 0, weight: 0 },
}

export default function useModalDetalhesPorEmpresa() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      resetState() {
        setState({ ...INITIAL_STATE })
      },

      // Events
      onInit(data, entregas) {
        setState(prevState => ({
          ...prevState,
          data: data,
          entregas,
          loadingMessage: LOAD_MESSAGE.LOAD_DATA,
        }))
      },

      loadData(data, entregas) {
        const buildGroupedByCompany = filteredEntregas => {
          const total = { nfs: 0, volumes: 0, sku: 0, weight: 0 }
          const grouped = filteredEntregas.reduce((acc, entrega) => {
            const company = entrega.company_name
            if (!acc[company]) {
              acc[company] = { company_name: company, qte_nfs: 0, qte_volumes: 0, qte_sku: 0, weightTotal: 0 }
            }
            total.nfs += 1
            total.volumes += entrega.qte_volumes || 0
            total.sku += entrega.qte_sku || 0
            total.weight += entrega.weightTotal
            acc[company].qte_nfs += 1
            acc[company].qte_volumes += entrega.qte_volumes || 0
            acc[company].qte_sku += entrega.qte_sku || 0
            acc[company].weightTotal += entrega.weightTotal
            return acc
          }, {})
          return { byCompany: Object.values(grouped), total }
        }

        const buildGroupedByCidade = (filteredEntregas, includeUf) => {
          const groupedByCity = filteredEntregas.reduce((acc, entrega) => {
            const cidadeLabel = includeUf
              ? `${entrega.city || 'Sem Cidade'} - ${entrega.uf_sigla || entrega.uf || ''}`
              : (entrega.city || 'Sem Cidade')
            if (!acc[cidadeLabel]) {
              acc[cidadeLabel] = {
                cidadeUf: cidadeLabel,
                qte_nfs: 0,
                qte_volumes: 0,
                qte_sku: 0,
                weightTotal: 0,
                empresas: {},
              }
            }
            acc[cidadeLabel].qte_nfs += 1
            acc[cidadeLabel].qte_volumes += entrega.qte_volumes || 0
            acc[cidadeLabel].qte_sku += entrega.qte_sku || 0
            acc[cidadeLabel].weightTotal += entrega.weightTotal
            const company = entrega.company_name
            if (!acc[cidadeLabel].empresas[company]) {
              acc[cidadeLabel].empresas[company] = { company_name: company, qte_nfs: 0, qte_volumes: 0, qte_sku: 0, weightTotal: 0 }
            }
            acc[cidadeLabel].empresas[company].qte_nfs += 1
            acc[cidadeLabel].empresas[company].qte_volumes += entrega.qte_volumes || 0
            acc[cidadeLabel].empresas[company].qte_sku += entrega.qte_sku || 0
            acc[cidadeLabel].empresas[company].weightTotal += entrega.weightTotal
            return acc
          }, {})
          return Object.values(groupedByCity).map(city => ({ ...city, empresas: Object.values(city.empresas) }))
        }

        if (data.uf) {
          const filteredEntregas = entregas.filter(entrega => entrega.uf === data.uf)
          const { byCompany, total } = buildGroupedByCompany(filteredEntregas)
          const byCity = buildGroupedByCidade(filteredEntregas, false)
          setState(prevState => ({
            ...prevState,
            byCompany,
            byCity,
            ufLabel: data.uf,
            loadingMessage: LOAD_MESSAGE.NONE,
            total,
          }))
          return
        }

        if (data.tp) {
          const filteredEntregas = entregas.filter(entrega => entrega.tp_name === data.tp)
          const { byCompany, total } = buildGroupedByCompany(filteredEntregas)
          const byCity = buildGroupedByCidade(filteredEntregas, true)
          setState(prevState => ({
            ...prevState,
            byCompany,
            byCity,
            ufLabel: null,
            activeTabIndex: 0,
            loadingMessage: LOAD_MESSAGE.NONE,
            total,
          }))
          return
        }
      },

      onTabChange(index) {
        setState(prevState => ({
          ...prevState,
          activeTabIndex: index,
        }))
      },

    }
  }, [])

  return { state, localDispatch }
}
